module.exports = __webpack_public_path__ + "img/icon-borrar.17982390.svg";